import { Button, Stack, Text } from '@mantine/core';
import { IconCircleCheckFilled } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { providerUserProfilePath } from '../../../lib/userProfileRouteAccess';
import type { Practice, User } from '../types/rbac';

export interface StaffAddClientSuccessProps {
  clientName: string;
  user: User;
  practice: Practice;
  onClose: () => void;
}

export function StaffAddClientSuccess({
  clientName,
  user,
  practice,
  onClose,
}: StaffAddClientSuccessProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <Stack gap="xl" align="center" py="xl" style={{ maxWidth: 400, margin: '0 auto' }}>
      <IconCircleCheckFilled size={56} style={{ color: 'var(--mantine-color-gold-5)' }} />
      <Stack gap={6} align="center">
        <Text className="intake-step-title" fw={700} ta="center">
          Client added
        </Text>
        <Text size="sm" c="dimmed" ta="center">
          {clientName} is on the practice roster and their episode of care is ready.
        </Text>
      </Stack>
      <Stack gap="sm" w="100%">
        <Button
          color="gold"
          fullWidth
          onClick={() => {
            onClose();
            navigate(providerUserProfilePath(user.id, user.role), {
              state: {
                user,
                fromPracticeSettingsTab: 'users',
                fromPracticeId: practice.id,
              },
            });
          }}
        >
          View client profile
        </Button>
        <Button variant="default" fullWidth onClick={onClose}>
          Back to users
        </Button>
      </Stack>
    </Stack>
  );
}
